module.exports = __webpack_public_path__ + "static/img/endesa.de205f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/endesa.png
// module id = K/sH
// module chunks = 1